import React from "react";

const Info = () => {
    return (
        <div className="features__wrapper__heading">
            <h2 className="heading-tag">Why choose Easybank?</h2>
            <p>
                We leverage Open Banking to turn your bank account into your
                financial hub. Control your finances like never before
            </p>
        </div>
    );
};

export default Info;
